import { h } from 'vue'
import { Icon } from '@iconify/vue'
// import { t } from '@/locales'

export interface PaginationConfig {
  page: number
  pageSize: number
  pageCount: number
  itemCount: number
  pageSizes: number[]
  showSizePicker: boolean
  showQuickJumper: boolean
  showQuickJumpDropdown: boolean
  pageSlot: number
  next: () => any
  prev: () => any
  onChange?: (page: number) => void
  onUpdatePageSize?: (pageSize: number) => void
}

const PAGINATION: PaginationConfig = {
  page: 1,
  pageSize: 10,
  pageCount: 0,
  itemCount: 0,
  pageSizes: [10, 25, 50, 100],
  showSizePicker: true,
  showQuickJumper: false,
  showQuickJumpDropdown: true,
  pageSlot: 9,
  next: () => h(
    'span',
    {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
      },
    },
    [
      // t('common.next'),
      h(Icon, {
        icon: 'ion:chevron-forward-outline',
        width: 16,
        height: 16,
      }),
    ],
  ),
  prev: () => h(
    'span',
    {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
      },
    },
    [
      h(Icon, {
        icon: 'ion:chevron-back-outline',
        width: 16,
        height: 16,
      }),
      // t('common.previous'),
    ],
  ),
}

export default PAGINATION
